<script>
import Vue from 'vue';
// import 'fullcalendar';
import CalendarMixins from '../../../shared/mixins/calendar-mixins';
import PostedAssetsList from './PostedAssetsList';
import PostedAssetSpot from './PostedAssetSpot';
import PriceModifierField from '../pricing/PriceModifierField';
import AssetCalendarCell from '../../calendar/partials/TeamCalendarCell';
import { Query } from '@jgile/laravel-vue';

const AssetCalendarCellClass = Vue.extend(AssetCalendarCell);
const ListItemClass = Vue.extend(PostedAssetsList);

export default {
    props: ['categories', 'rootCategory'],
    mixins: [CalendarMixins],
    components: {
        PriceModifierField,
        postedAssetSpot: PostedAssetSpot,
    },
    data() {
        return {
            url: null,
            query: new Query({
                filter: {
                    type: [],
                    category: [],
                },
            }),
            attributes: null,
            calendarView: 1,
            calendarConfig: {
                height: 'auto',
                unselectCancel: '.selection-config, .selection-config *, .modal *',
                listDayFormat: 'MMMM Do dddd',
                header: {
                    left: 'prev,next today title',
                    center: '',
                    right: 'month,listMonth',
                },
                bootstrapFontAwesome: {
                    month: 'fas fa-th',
                    listMonth: 'fas fa-bars',
                },
            },
            potentialYield: null,
            datePicker: null,
            pickerPage: {
                month: moment().month(),
                year: moment().year(),
            },
            filters: [],
            filterCategories: [],

            /* form data */
            modal: null,
            form: new SparkForm({}),
        };
    },
    watch: {
        'query.filter': {
            deep: true,
            handler(newVal) {
                this.refetchEvents();
            },
        },
    },
    created() {
        const _this = this;
        this.calendar.singleDaySelect = true;
        Bus.$on('priceModifierSaved', this.priceModifierSaved);
        Bus.$on('postedAssetUpdated', this.refetchEvents);
        Bus.$on('listViewYieldChange', (payload) => {
            _this.potentialYield = _this.potentialYield + payload.change;
        });

        this.$nextTick(function () {
            this.modal = $(this.$refs.modal);
            this.modal.modal({ show: false });
        });
    },
    beforeDestroy() {
        Bus.$off('priceModifierSaved', this.priceModifierSaved);
        Bus.$off('postedAssetUpdated', this.refetchEvents);
    },
    methods: {
        priceModifierSaved() {
            this.modal.modal('hide');
            this.refetchEvents();
        },
        toggleView() {
            let view = this.calendar.obj.fullCalendar('getView');
            if (view.type === 'month') {
                this.calendar.obj.fullCalendar('changeView', 'listMonth');
            } else {
                this.calendar.obj.fullCalendar('changeView', 'month');
            }
        },
        prev() {
            this.calendar.obj.fullCalendar('prev');
        },
        next() {
            this.calendar.obj.fullCalendar('next');
        },
        getCalendarData(start, end, timezone, callback) {
            const _this = this;
            this.$messenger.loading(this.$refs.calendar);
            this.query.filter.start = start.format();
            this.query.filter.end = end.format();
            this.query.get('/api/team/posted-assets/calendar').then((response) => {
                _this.calendar.events = _this.$vueData.getData(response);
                _this.onGetCalendarData(_this.calendar.events, start, end);
                this.$messenger.loaded(this.$refs.calendar);
                callback(_this.calendar.events);
            });
        },

        /**
         * Filters
         */
        onCalendarSelection(start) {
            if (this.calView && this.calendar.selectedEvent) {
                this.$nextTick(function () {
                    this.modal.modal('show');
                });
            }
        },
        fromPage(val) {
            if (val && val.title) {
                let date = val.year + '-' + val.month + '-' + '1';
                this.pickMonth(moment(date, 'YYYY-MM-DD'));
            }
        },
        monthChanged({ instance }) {
            let date = moment(instance.currentYear + '-' + (instance.currentMonth + 1) + '-01', 'YYYY-M-DD');
            this.pickMonth(date);
        },
        dayClicked(day) {
            this.scrollToDay(day);
        },
        onGetCalendarData(data, start) {
            this.potentialYield = _.chain(data)
                .sumBy((item) => {
                    return _.chain(item.products).sumBy('potential_yield').value();
                })
                .value();

            let enabled = _.map(data, (item, key) => {
                return moment(item.start);
            });

            this.attributes = _.chain(data)
                .filter((dataItem, something) => {
                    return dataItem.schedule;
                })
                .keyBy('start')
                .value();

            enabled = enabled.length ? enabled : [moment('2015-01-01')];
            let viewDate = start.date() === 1 ? start : start.add(1, 'month').startOf('month');

            this.pickerPage = {
                month: viewDate.month() + 1,
                year: viewDate.year(),
            };
        },

        /**
         * Calendar Events
         */
        scrollToDay(date) {
            let row = $('.date-' + moment(date).format('YYYY-MM-DD')).first();
            if (row.length) {
                let card = row.find('.card').first();

                row[0].scrollIntoView({
                    alignToTop: true,
                    behavior: 'smooth',
                    block: 'start',
                });

                card.addClass('flash-border');

                setTimeout(() => {
                    card.removeClass('flash-border');
                }, 1000);
            }
        },
        testing() {
            alert('testing');
        },
        pickMonth(date) {
            this.calendar.obj.fullCalendar('gotoDate', date);
        },
        eventRender(event, element, view) {
            if (view.name === 'listMonth') {
                this.calendar.selectedScheduleDate = _.find(this.calendar.schedule, (item) => {
                    return item.start === dateTimeString(event.start, 'YYYY-MM-DD');
                });

                const instance = new ListItemClass({
                    propsData: {
                        day: event,
                        priceModifier: _.get(this.calendar.selectedScheduleDate, 'price_modifier'),
                    },
                });
                instance.$mount();
                element.html(instance.$el);
            } else {
                const instance = new AssetCalendarCellClass({
                    propsData: {
                        event: event,
                        element: element,
                        config: { icons: true },
                        leadTime: this.leadTime,
                    },
                });
                instance.$mount();
                element.html(instance.$el);
            }
        },
    },
    computed: {
        priceModifier() {
            return _.get(this.calendar, 'selectedPriceModifier');
        },
        eventName() {
            return _.get(this.calendar, 'selectedScheduleDate.title');
        },
        modalDay() {
            return moment(this.calendar.selectedEvent.start).format('dddd');
        },
        modalDate() {
            return moment(this.calendar.selectedEvent.start).date();
        },
        dataUrl() {
            return '/api/team/posted-assets/calendar';
        },
        listView() {
            return this.calendar.view === 'listMonth';
        },
        calView() {
            return this.calendar.view === 'month';
        },
    },
};
</script>
